// product-visualizer.js migliorato
document.addEventListener('DOMContentLoaded', function() {
  // Configurazione iniziale
  const visualizerContainer = document.getElementById('product-visualizer');
  if (!visualizerContainer) return; // Protezione se l'elemento non esiste
  
  const productImageElement = document.querySelector('.product__media img');
  const productImage = productImageElement ? productImageElement.src : '';
  
  if (!productImage) {
    console.error('Immagine prodotto non trovata');
    return;
  }
  
  // Crea struttura HTML con z-index espliciti, contenitore delimitato e posizione relativa
  visualizerContainer.innerHTML = `
    <div class="visualizer-wrapper" style="position: relative; overflow: hidden;">
      <div class="image-upload-area" id="uploadArea" style="z-index: 10;">
        <input type="file" id="roomImage" accept="image/*" class="hidden" style="display: none;">
        <label for="roomImage" class="upload-label" style="cursor: pointer; display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 2rem; border: 2px dashed #ccc; border-radius: 8px;">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="upload-icon">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
            <polyline points="17 8 12 3 7 8"></polyline>
            <line x1="12" y1="3" x2="12" y2="15"></line>
          </svg>
          <span>Carica una foto del tuo ambiente</span>
        </label>
      </div>
      
      <div class="visualizer-controls" id="controls" style="display: none; margin-top: 1rem; z-index: 20;">
        <div class="size-control" style="margin-bottom: 0.5rem;">
          <label>Dimensione</label>
          <input type="range" min="5" max="50" value="20" id="sizeSlider">
        </div>
        <div class="rotation-control" style="margin-bottom: 0.5rem;">
          <label>Rotazione</label>
          <input type="range" min="0" max="360" value="0" id="rotationSlider">
        </div>
        <button id="resetBtn" style="padding: 0.5rem 1rem; background: #f5f5f5; border: 1px solid #ddd; border-radius: 4px; cursor: pointer;">Riprova</button>
      </div>
      
      <div class="preview-area" id="previewArea" style="display: none; position: relative; width: 100%; border: 1px solid #eee; z-index: 5; overflow: hidden;">
        <div style="position: relative; width: 100%;">
          <img id="roomPreview" src="" alt="Il tuo ambiente" style="width: 100%; display: block;">
          <div id="productPreview" class="product-preview" style="position: absolute; width: 20%; top: 10%; left: 10%; transform: rotate(0deg); cursor: grab; z-index: 30; user-select: none; touch-action: none;">
            <img src="${productImage}" alt="Prodotto" style="width: 100%; display: block; pointer-events: none;">
          </div>
        </div>
      </div>
    </div>
  `;
  
  // Elementi DOM
  const fileInput = document.getElementById('roomImage');
  const controls = document.getElementById('controls');
  const previewArea = document.getElementById('previewArea');
  const uploadArea = document.getElementById('uploadArea');
  const productPreview = document.getElementById('productPreview');
  const sizeSlider = document.getElementById('sizeSlider');
  const rotationSlider = document.getElementById('rotationSlider');
  
  // Gestione caricamento immagine
  fileInput.addEventListener('change', handleImageUpload);
  
  // Aggiungi drag-and-drop per il caricamento delle immagini
  uploadArea.addEventListener('dragover', (e) => {
    e.preventDefault();
    uploadArea.style.borderColor = '#888';
    uploadArea.style.backgroundColor = 'rgba(0,0,0,0.05)';
  });
  
  uploadArea.addEventListener('dragleave', (e) => {
    e.preventDefault();
    uploadArea.style.borderColor = '#ccc';
    uploadArea.style.backgroundColor = 'transparent';
  });
  
  uploadArea.addEventListener('drop', (e) => {
    e.preventDefault();
    uploadArea.style.borderColor = '#ccc';
    uploadArea.style.backgroundColor = 'transparent';
    
    if (e.dataTransfer.files.length) {
      fileInput.files = e.dataTransfer.files;
      handleImageUpload({ target: { files: e.dataTransfer.files } });
    }
  });
  
  function handleImageUpload(e) {
    const file = e.target.files[0];
    if (file && file.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.onload = function(event) {
        const roomPreview = document.getElementById('roomPreview');
        roomPreview.src = event.target.result;
        
        // Aspetta che l'immagine sia caricata per calcolare le proporzioni
        roomPreview.onload = function() {
          // Imposta un'altezza massima per il contenitore
          uploadArea.style.display = 'none';
          controls.style.display = 'block';
          previewArea.style.display = 'block';
          
          // Posiziona il prodotto inizialmente in alto a sinistra (10%, 10%)
          productPreview.style.left = '10%';
          productPreview.style.top = '10%';
          productPreview.style.transform = 'rotate(0deg)';
          sizeSlider.value = 20;
          rotationSlider.value = 0;
        };
      };
      reader.readAsDataURL(file);
    }
  }
  
  // Controlli prodotto
  sizeSlider.addEventListener('input', updateProductSize);
  rotationSlider.addEventListener('input', updateProductRotation);
  
  function updateProductSize(e) {
    const size = e.target.value;
    productPreview.style.width = `${size}%`;
  }
  
  function updateProductRotation(e) {
    const angle = e.target.value;
    productPreview.style.transform = `rotate(${angle}deg)`;
  }
  
  // Pulsante Reset
  document.getElementById('resetBtn').addEventListener('click', () => {
    uploadArea.style.display = 'block';
    controls.style.display = 'none';
    previewArea.style.display = 'none';
    fileInput.value = '';
  });
  
  // Drag and Drop del prodotto MIGLIORATO
  let isDragging = false;
  let startX, startY, startLeft, startTop;
  
  // Supporto sia per mouse che per touch
  productPreview.addEventListener('mousedown', startDragging);
  productPreview.addEventListener('touchstart', handleTouchStart, { passive: false });
  
  function handleTouchStart(e) {
    e.preventDefault(); // Previene lo scroll durante il touch
    const touch = e.touches[0];
    startDragging({
      clientX: touch.clientX,
      clientY: touch.clientY,
      type: 'touch'
    });
  }
  
  function startDragging(e) {
    isDragging = true;
    
    const rect = productPreview.getBoundingClientRect();
    const previewRect = previewArea.getBoundingClientRect();
    
    // Salva la posizione iniziale del mouse/touch e dell'elemento
    startX = e.clientX;
    startY = e.clientY;
    
    // Converti la posizione corrente da percentuale a pixel
    startLeft = (parseFloat(productPreview.style.left) / 100) * previewRect.width;
    startTop = (parseFloat(productPreview.style.top) / 100) * previewRect.height;
    
    productPreview.style.cursor = 'grabbing';
    
    if (e.type !== 'touch') {
      document.addEventListener('mousemove', drag);
      document.addEventListener('mouseup', stopDragging);
    } else {
      document.addEventListener('touchmove', handleTouchMove, { passive: false });
      document.addEventListener('touchend', stopDragging);
    }
    
    e.stopPropagation();
  }
  
  function handleTouchMove(e) {
    e.preventDefault();
    const touch = e.touches[0];
    drag({
      clientX: touch.clientX,
      clientY: touch.clientY
    });
  }
  
  function drag(e) {
    if (!isDragging) return;
    
    const previewRect = previewArea.getBoundingClientRect();
    
    // Calcola lo spostamento rispetto alla posizione iniziale
    const deltaX = e.clientX - startX;
    const deltaY = e.clientY - startY;
    
    // Calcola la nuova posizione in pixel
    const newLeft = startLeft + deltaX;
    const newTop = startTop + deltaY;
    
    // Converti in percentuale per un posizionamento responsivo
    const leftPercent = (newLeft / previewRect.width) * 100;
    const topPercent = (newTop / previewRect.height) * 100;
    
    // Limita il prodotto all'interno dell'area di anteprima
    const minX = 0;
    const maxX = 100 - parseFloat(productPreview.style.width);
    const minY = 0;
    const maxY = 100 - parseFloat(productPreview.style.width);
    
    const limitedX = Math.min(Math.max(minX, leftPercent), maxX);
    const limitedY = Math.min(Math.max(minY, topPercent), maxY);
    
    productPreview.style.left = `${limitedX}%`;
    productPreview.style.top = `${limitedY}%`;
    
    e.preventDefault();
  }
  
  function stopDragging() {
    if (!isDragging) return;
    
    isDragging = false;
    productPreview.style.cursor = 'grab';
    
    document.removeEventListener('mousemove', drag);
    document.removeEventListener('touchmove', handleTouchMove);
    document.removeEventListener('mouseup', stopDragging);
    document.removeEventListener('touchend', stopDragging);
  }
  
  // Impedisci che lo scrolling della pagina venga influenzato
  visualizerContainer.addEventListener('wheel', function(e) {
    if (previewArea.style.display !== 'none') {
      // Se l'area di anteprima è visibile, preveniamo lo scrolling solo se il mouse è sopra di essa
      const rect = previewArea.getBoundingClientRect();
      if (
        e.clientX >= rect.left && 
        e.clientX <= rect.right && 
        e.clientY >= rect.top && 
        e.clientY <= rect.bottom
      ) {
        e.stopPropagation();
      }
    }
  }, { capture: true });
  
  // Impedisci che il contenuto del visualizzatore fuoriesca dal suo contenitore
  // Setta esplicitamente la posizione del visualizzatore a relative
  visualizerContainer.style.position = 'relative';
  visualizerContainer.style.zIndex = '1'; // Imposta un z-index basso ma positivo
});